import { css, keyframes } from 'styled-components';
import { Keyframes } from 'styled-components/dist/types';

export const createHeightAnimation = (from: number, to: number) => keyframes`
  0% {
    height: ${from}px;
  }
  100% {
    height: ${to}px;
  }
`;

export const getHeaderAnimation = ({
  isCondensed,
  shrinkAnimation,
  expandAnimation,
}: {
  isCondensed: boolean;
  shrinkAnimation: Keyframes;
  expandAnimation: Keyframes;
}) => css`
  animation: ${isCondensed ? shrinkAnimation : expandAnimation} 0.2s ease-out;
`;
